export const RealtimeMessageAction = {
  New: 0,
  Update: 1,
} as const;

export type RealtimeMessageAction =
  (typeof RealtimeMessageAction)[keyof typeof RealtimeMessageAction];
